<template>
    <section class="">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
                     @review="handleReview"
                     :btn_add="canAdd"
                     btn_review
        >

            <div class="pull-right" v-if="incomplete">
                <router-link to="/questionnaire" class="questionnaire text-danger">{{incomplete}}个问卷未完成</router-link> |
                <router-link to="/calendar" class="questionnaire text-info">查看日历</router-link>
            </div>
        </front-table>
        <!--编辑界面-->

        <meeting-view :view_mode="view_mode" :single="single" @start="startMeeting" @mail="mailAttendees"
                      @cancel="view_mode = false">
        </meeting-view>
    </section>
</template>

<script>
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";
    import MeetingView from "../components/meeting-view";
    export default {
        mixins: [FrontMixins],
        name: 'my-meeting',
        components: {MeetingView, FrontTable},
        data(){
          return {incomplete:0}
        },
        created() {
            this.model = 'Meeting';
            this.$api("User.Incomplete",{},true).then(res=>{
               this.incomplete = parseInt( res.data.data );
            });
        },
        methods: {
            startMeeting() {
                this.$api(this.model + '.Host', {id: this.single.id, review: true}, true).then(res => {
                    let host_url = res.data.data.host_url;
                    window.open(host_url, '_blank');
                    this.view_mode = false;
                });
            },
            mailAttendees() {
                let vm = this;
                this.$api(this.model + '.Mail.Attendee', {id: this.single.id}, true).then(() => {
                    vm.$messageBox.success("邮件已经发送给参会者!");
                });
            },
            handleEdit(id) {
                if (id == 0) {
                    this.$router.push('/new');
                } else {
                    this.$router.push('/edit/' + id);
                }
            },
        }
    }
</script>

<style lang="scss">
    .questionnaire {
        line-height: 36px;
        font-size: 1.2em;

        a {
            color: #dc3545 !important;
            font-weight: normal;

            &:hover {
                text-decoration: none;
                font-weight: bold;
            }
        }
    }

</style>
